import { Clock } from 'lucide-react'

import { formatEventWindowUTC } from '../../lib/time'

export interface TimeframeCalloutProps {
  /** ISO-8601 UTC start of the window. Renders nothing when absent. */
  start?: string
  /** Optional ISO-8601 UTC end of the window. */
  end?: string
}

/**
 * Prominent, operator-facing callout for the timeframe to investigate (e.g. to
 * pull camera footage). Deliberately high-contrast — a tinted, bordered banner
 * with a clock icon and large 24-hour UTC time — so it reads at a glance
 * instead of disappearing into the surrounding prose.
 */
export function TimeframeCallout({ start, end }: TimeframeCalloutProps) {
  if (!start) return null
  const label = formatEventWindowUTC(start, end)
  if (!label) return null
  return (
    <div className="flex items-center gap-3 rounded-lg border border-st-info/50 bg-st-info-bg/50 px-4 py-3">
      <Clock aria-hidden className="size-6 shrink-0 text-st-info" />
      <div className="min-w-0">
        <div className="text-11 font-semibold uppercase tracking-wide text-st-info">
          Timeframe to investigate
        </div>
        <div className="text-lg font-semibold leading-tight tabular-nums text-ink">{label}</div>
      </div>
    </div>
  )
}
